import LikertQuestion from './LikertQuestion';
export default LikertQuestion;